import { useCallback, useRef } from 'react';

import ReactPlayer from 'react-player';

import styles from './Player.module.scss';

interface PlayerProps {
  videoUrl: string;
  subtitlesUrl?: string;
}

export default function Player({ videoUrl, subtitlesUrl }: PlayerProps) {
  const playerRef = useRef<HTMLVideoElement>(null);

  const removeEmptyCues = useCallback(() => {
    const video = playerRef.current;

    if (!video) {
      return;
    }

    const subtitleTrack = Array.from(video.textTracks).find(
      (track) => track.kind === 'subtitles',
    );

    const cues = subtitleTrack?.cues;

    if (!cues) {
      return;
    }

    for (let i = 0; i < cues.length; i++) {
      const cue = cues[i];

      if (cue instanceof VTTCue && !cue.text.trim()) {
        subtitleTrack.removeCue(cue);
      }
    }
  }, []);

  return (
    <>
      {!videoUrl && 'Please provide videoUrl param'}
      {videoUrl && !ReactPlayer.canPlay?.(videoUrl) && 'Video not supported'}
      {videoUrl && ReactPlayer.canPlay?.(videoUrl) && (
        <ReactPlayer
          ref={playerRef}
          className={styles.reactPlayer}
          controls
          crossOrigin="anonymous"
          height="100%"
          src={videoUrl}
          width="100%"
          onReady={removeEmptyCues}
        >
          {subtitlesUrl && (
            <track
              default
              kind="subtitles"
              label="Subtitles"
              src={subtitlesUrl}
              srcLang="en"
            />
          )}
        </ReactPlayer>
      )}
    </>
  );
}
